"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLE = exports.STATE = exports.CURRENCY = exports.ACTION_NAME = void 0;
/** Enum of name possible in a action */
var ACTION_NAME;
(function (ACTION_NAME) {
    ACTION_NAME["CREATE"] = "create";
    ACTION_NAME["BROADCAST"] = "broadcastSignedRequest";
    ACTION_NAME["ACCEPT"] = "accept";
    ACTION_NAME["CANCEL"] = "cancel";
    ACTION_NAME["REDUCE_EXPECTED_AMOUNT"] = "reduceExpectedAmount";
    ACTION_NAME["INCREASE_EXPECTED_AMOUNT"] = "increaseExpectedAmount";
    ACTION_NAME["ADD_STAKEHOLDERS"] = "addStakeholders";
    ACTION_NAME["ADD_EXTENSIONS_DATA"] = "addExtensionsData";
})(ACTION_NAME || (exports.ACTION_NAME = ACTION_NAME = {}));
/** Supported currencies */
var CURRENCY;
(function (CURRENCY) {
    /** ETH Currency type refers to any kind of blockchain native currency - excepted bitcoin */
    CURRENCY["ETH"] = "ETH";
    /** BTC Currency type refers to the Bitcoin native currency */
    CURRENCY["BTC"] = "BTC";
    /** ISO4217 Currency type refers to fiat currencies (e.g. EUR, USD, ...) */
    CURRENCY["ISO4217"] = "ISO4217";
    /** ERC20 Currency type refers to any kind of fungible token (USDC, DAI, ...) */
    CURRENCY["ERC20"] = "ERC20";
    /** ERC777 Currency type refers to any kind of streamable fungible token (USDCx, DAIx, ...) */
    CURRENCY["ERC777"] = "ERC777";
})(CURRENCY || (exports.CURRENCY = CURRENCY = {}));
/** States of a request */
var STATE;
(function (STATE) {
    // use for upper layer (trick to avoid headache with retyping request in upper layer)
    STATE["PENDING"] = "pending";
    STATE["CREATED"] = "created";
    STATE["ACCEPTED"] = "accepted";
    STATE["CANCELED"] = "canceled";
})(STATE || (exports.STATE = STATE = {}));
/** Identity roles */
var ROLE;
(function (ROLE) {
    ROLE["PAYEE"] = "payee";
    ROLE["PAYER"] = "payer";
    ROLE["THIRD_PARTY"] = "third-party";
})(ROLE || (exports.ROLE = ROLE = {}));
//# sourceMappingURL=request-logic-types.js.map